import { IApplicationState } from '../../types/redux';

export function getNewBuildings(state: IApplicationState) {
  return state.newBuildings;
}
